/// <amd-module name="Search/WorkItem/Services/WorkItemDialogService" />
import * as React from "react";
import { Services, VssService, IVssService } from "VSS/Platform/Context";
import { IVssLayoutManager } from "VSS/Platform/Layout";
import { LegacyComponent } from "VSS/Legacy/Legacy";

export interface IWorkItemDialogService extends IVssService {
    /**
      * Open the work item with the given id
      *
      * @param workItemId Id of the work item to open
      */
    openWorkItem(workItemId: number, options?: any): void;
}

class WorkItemDialogService extends VssService implements IWorkItemDialogService {
    public async openWorkItem(workItemId: number, options?: any): Promise<void> {
        const layoutManager = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        layoutManager.renderCallout(onDismiss => {
            return React.createElement(LegacyComponent, {
                modules: ["WorkItemTracking/SharedScripts/WorkItemDialogShim"],
                wrappedType: "WorkItemDialog",
                workItemId,
                onDismiss,
                options
            });
        });
    }
}

Services.add("IWorkItemDialogService", { serviceFactory: WorkItemDialogService });
